<template>
  <div>
    <el-container class="container">
      <!-- label-width="190px" label-position="left" -->
      <el-form v-loading="loading" style="margin:0 auto; width:98%;" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
          <div class="textInfo">
            <div style="font-weight:600;">关于第十九届（2024年）全国大学生智能汽车竞赛样品申请说明：</div>
            <div>经大赛方统一协调，为保障参赛芯片公平有序发放，沁恒赞助芯片CH32V307及WCH-LinkE将只在统一样片申请通道审核发放。</div>
            <div><span style="font-weight:600;">申请链接：</span><a href="http://seekfree.mikecrm.com/x7yJKdf" style="color:#409eff" target="_blank">http://seekfree.mikecrm.com/x7yJKdf</a></div>
             
            <div><span style="font-weight:600;">特此提醒：</span>官网与智能汽车竞赛相关样品申请邮件将不作处理，敬请理解！预祝参赛选手赛出风格，勇夺佳绩。</div>
          </div>
          <el-form-item label="学校名称：" prop="school">
            <el-input  v-model="ruleForm.school"  placeholder="请输入学校名称" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contact">
            <el-input  v-model="ruleForm.contact"  placeholder="请输入联系人姓名" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item label="手机号码：" prop="phone">
            <el-input  v-model="ruleForm.phone"  placeholder="请输入手机号码" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item label="地址：" prop="address">
            <el-input  v-model="ruleForm.address"  maxlength="50" show-word-limit placeholder="请输入地址" style="width:100%;"></el-input>
          </el-form-item>
          <el-form-item label="Email：" prop="email">
            <el-input  v-model="ruleForm.email"  placeholder="请输入邮箱" style="width:100%;"></el-input>
          </el-form-item>
          <!-- <el-divider></el-divider> -->

          <el-form-item label="产品型号：" >
            <div style="text-align:left;">（勾选的样品默认为该型号对应的 开发板*1块+芯片*2片 组合）</div>
          </el-form-item>
          <div class="borderClass">
          <el-form-item label="通用RISC-V系列MCU" prop="publicMCU" >
            <el-checkbox-group  v-model="ruleForm.publicMCU" style="width:100%; text-align:left;" @change="publicMCUChange">
              <el-checkbox label="CH32V003F4P6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V003.html')" >CH32V003F4P6</span></el-tooltip> </el-checkbox>
              <!-- <el-checkbox label="CH32V103C8T6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V103.html')" >CH32V103C8T6</span></el-tooltip> </el-checkbox> -->
              <el-checkbox label="CH32V203C8T6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V203.html')" >CH32V203C8T6</span></el-tooltip> </el-checkbox>
              <el-checkbox label="CH32V307VCT6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V307.html')" >CH32V307VCT6</span></el-tooltip> </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="RISC-V低功耗蓝牙系列MCU" prop="lowPowerMCU" >
            <el-checkbox-group  v-model="ruleForm.lowPowerMCU" style="width:100%; text-align:left;" @change="lowPowerMCUChange">
              <!-- <el-checkbox label="CH573F"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH573.html')" >CH573F</span></el-tooltip></el-checkbox> -->
              <el-checkbox label="CH582M"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH583.html')" >CH582M</span></el-tooltip></el-checkbox>
              <el-checkbox label="CH32V208WBU6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V208.html')" >CH32V208WBU6</span></el-tooltip></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="USB系列接口芯片" prop="seriesUSB" >
            <el-checkbox-group  v-model="ruleForm.seriesUSB" style="width:100%; text-align:left;"  @change="seriesUSBChange">
              <el-checkbox label="CH343G"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH343.html')" >CH343G</span></el-tooltip></el-checkbox>
              <el-checkbox label="CH347T"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH347.html')" >CH347T</span></el-tooltip></el-checkbox>
              <el-checkbox label="CH348Q"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH348.html')" >CH348Q</span></el-tooltip></el-checkbox>
              <el-checkbox label="CH334U"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH334.html')" >CH334U</span></el-tooltip></el-checkbox>
            </el-checkbox-group>
            <el-input v-show="ruleForm.publicMCU.length || ruleForm.lowPowerMCU.length || ruleForm.seriesUSB.length" type="textarea" maxlength="100" show-word-limit :autosize='{ minRows: 3 }' v-model="ruleForm.product1Desc" placeholder="请填写产品应用方向：如毕业设计，课程学习需描述课题名称并概述产品测评及开发计划；
              学科竞赛请补充大赛名称及所申请芯片在参赛作品中的主要功能"></el-input>
          </el-form-item>
          </div>
          
          <!-- 增加的采购型号 -->
          <div v-show="plusShow" class="borderClass">
            <el-divider></el-divider>
            <el-form-item label="通用RISC-V系列MCU" >
              <el-checkbox-group  v-model="ruleForm.publicMCU2" style="width:100%; text-align:left;" @change="publicMCUChange2">
                <el-checkbox label="CH32V003F4P6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V003.html')" >CH32V003F4P6</span></el-tooltip> </el-checkbox>
                <!-- <el-checkbox label="CH32V103C8T6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V103.html')" >CH32V103C8T6</span></el-tooltip> </el-checkbox> -->
                <el-checkbox label="CH32V203C8T6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V203.html')" >CH32V203C8T6</span></el-tooltip> </el-checkbox>
                <el-checkbox label="CH32V307VCT6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V307.html')" >CH32V307VCT6</span></el-tooltip> </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="RISC-V低功耗蓝牙系列MCU" >
              <el-checkbox-group  v-model="ruleForm.lowPowerMCU2" style="width:100%; text-align:left;" @change="lowPowerMCUChange2">
                <!-- <el-checkbox label="CH573F"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH573.html')" >CH573F</span></el-tooltip></el-checkbox> -->
                <el-checkbox label="CH582M"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH583.html')" >CH582M</span></el-tooltip></el-checkbox>
                <el-checkbox label="CH32V208WBU6"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH32V208.html')" >CH32V208WBU6</span></el-tooltip></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="USB系列接口芯片">
              <el-checkbox-group  v-model="ruleForm.seriesUSB2" style="width:100%; text-align:left;"  @change="seriesUSBChange2">
                <el-checkbox label="CH343G"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH343.html')" >CH343G</span></el-tooltip></el-checkbox>
                <el-checkbox label="CH347T"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH347.html')" >CH347T</span></el-tooltip></el-checkbox>
                <el-checkbox label="CH348Q"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH348.html')" >CH348Q</span></el-tooltip></el-checkbox>
                <el-checkbox label="CH334U"> <el-tooltip class="item" effect="dark" content="双击查看介绍" placement="top-start"><span class="chipModel" @dblclick="dblclickChipModel('https://www.wch.cn/products/CH334.html')" >CH334U</span></el-tooltip></el-checkbox>
              </el-checkbox-group>
              <el-input v-show="ruleForm.publicMCU2.length || ruleForm.lowPowerMCU2.length || ruleForm.seriesUSB2.length" type="textarea"  maxlength="100" show-word-limit :autosize='{ minRows: 3 }' v-model="ruleForm.product2Desc" placeholder="请填写产品应用方向：如毕业设计，课程学习需描述课题名称并概述产品测评及开发计划；
                学科竞赛请补充大赛名称及所申请芯片在参赛作品中的主要功能"></el-input>
            </el-form-item>
          </div>

          <!-- <div style="margin-bottom:15px;">
            <el-button type="success" plain size="small" v-show="!plusShow" @click="clickPlus" ><i class="el-icon-plus" ></i>增加样品申请型号</el-button>
            <el-button type="danger" plain size="small" v-show="plusShow" @click="clickDelete"> <i class="el-icon-delete" ></i>删除</el-button>
          </div> -->


          <!-- <el-form-item label="其他需求型号" prop="other">
            <el-input  v-model="ruleForm.other"  placeholder="请输入完整型号名称" style="width:100%;"></el-input>
            <el-input  style="margin-top:15px;" v-show="ruleForm.other" type="textarea" :autosize='{ minRows: 3 }' v-model="ruleForm.otherDesc" placeholder="请填写产品应用方向：如毕业设计，课程学习需描述课题名称并概述产品测评及开发计划；
              学科竞赛请补充大赛名称及所申请芯片在参赛作品中的主要功能"></el-input>
          </el-form-item> -->
            <div style="margin-bottom: 15px; font-size: 14px; color: #606266; ">
              <el-checkbox  style="margin-right:10px;"  v-model="ruleForm.checkValue"> </el-checkbox>
              注：邮件信息务必准确齐全，样品统一顺丰或京东快递，运费到付，运费请参考顺丰或京东官网。
            </div>
          <div style="margin:0 auto;">
            <el-button type="primary" @click="submitForm('ruleForm')">发送邮件</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </div>
      </el-form>
      
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="400px"
        >
        <div style="width:100%;font-size:20px; text-align:center;"><i style="color:green;" class="el-icon-circle-check"></i> 样品已申请！</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>

  </div>
</template>

<script>
import { getAction, postAction, postFormAction} from '@/request/http'//引入封装的get post方法
export default {
  name: "Home",
  data() {
    return {
       ruleForm: {
          school: '',
          contact: '',
          phone: '',
          address: '',
          email: '',
          publicMCU: [],
          lowPowerMCU: [],
          seriesUSB: [],
          product1Desc:'',
          // other:'',
          // otherDesc:'',
          checkValue:false,
          publicMCU2: [],
          lowPowerMCU2: [],
          seriesUSB2: [],
          product2Desc:'',
        },
        rules: {
          school: [
            { required: true, message: '请输入学校名称', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          contact: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入正确的手机号码', pattern: /^1[0-9]{10}$/, trigger: 'blur' }
          ],
          address: [
            { required: true, message: '请输入地址', trigger: 'blur' }
          ],
          email: [
            { required: true, message: '请输入正确的邮箱', pattern: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/, trigger: 'blur' }
          ],
          checkValue: [
            { required: true, message: '请勾选注意事项', trigger: 'change' }
          ],
        },
        loading:false,
        plusShow:false,
        product1:'',
        product2:'',
        dialogVisible:false,
        url:{
          submitUrl:'/api/official/website/sample_orders/education/save'
        }
    };
  },
  mounted() {
  },
  methods:{
      publicMCUChange(val){
        console.log('val1---',val)
        this.product1=''
        if(val.length>0){//勾选
          // debugger
          this.ruleForm.lowPowerMCU=[]
          this.ruleForm.seriesUSB=[]
          let v = val[val.length-1]
          this.ruleForm.publicMCU=[v]
          this.product1 = v
        }
      } ,   
      lowPowerMCUChange(val){
        console.log('val2---',val)
        this.product1=''
        if(val.length>0){//勾选
          this.ruleForm.publicMCU=[]
          this.ruleForm.seriesUSB=[]
          let v = val[val.length-1]
          this.ruleForm.lowPowerMCU=[v]
          this.product1 = v
        }
      } ,
      seriesUSBChange(val){
        console.log('val3---',val)
        this.product1=''
        if(val.length>0){//勾选
          this.ruleForm.publicMCU=[]
          this.ruleForm.lowPowerMCU=[]
          let v = val[val.length-1]
          this.ruleForm.seriesUSB=[v]
          this.product1 = v
        }
      } ,

      publicMCUChange2(val){
        console.log('val1---',val)
        this.product2=''
        if(val.length>0){//勾选
          // debugger
          this.ruleForm.lowPowerMCU2=[]
          this.ruleForm.seriesUSB2=[]
          let v = val[val.length-1]
          this.ruleForm.publicMCU2=[v]
          this.product2 = v
        }
      } ,   
      lowPowerMCUChange2(val){
        console.log('val2---',val)
        this.product2=''
        if(val.length>0){//勾选
          this.ruleForm.publicMCU2=[]
          this.ruleForm.seriesUSB2=[]
          let v = val[val.length-1]
          this.ruleForm.lowPowerMCU2=[v]
          this.product2 = v
        }
      } ,
      seriesUSBChange2(val){
        console.log('val3---',val)
        this.product2=''
        if(val.length>0){//勾选
          this.ruleForm.publicMCU2=[]
          this.ruleForm.lowPowerMCU2=[]
          let v = val[val.length-1]
          this.ruleForm.seriesUSB2=[v]
          this.product2 = v
        }
      } ,

      clickPlus(){
        this.plusShow=true
      },
      clickDelete(){
        this.plusShow=false
        this.ruleForm.publicMCU2=[]
        this.ruleForm.lowPowerMCU2=[]
        this.ruleForm.seriesUSB2=[]
        this.product2=''
        this.ruleForm.product2Desc=''

      },

      //双击芯片型号
      dblclickChipModel(link){
        window.open(link,'_blank');     
      },

     
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('1,2',this.product1,this.product2)
            if((this.ruleForm.publicMCU.length > 0 || this.ruleForm.lowPowerMCU.length > 0 || this.ruleForm.seriesUSB.length > 0) && !this.ruleForm.product1Desc){
              this.$message({
                message: '请填写产品应用方向！',
                type: 'warning'
              });
              return
            }
            if((this.ruleForm.publicMCU2.length > 0 || this.ruleForm.lowPowerMCU2.length > 0 || this.ruleForm.seriesUSB2.length > 0) && !this.ruleForm.product2Desc ){
              this.$message({
                message: '请填写产品应用方向！',
                type: 'warning'
              });
              return
            }
            if(this.product1&&this.product2&&this.product1==this.product2){
              this.$message({
                message: '不能同时申请两个同样的产品型号！',
                type: 'warning'
              });
              return
            }
            if(!this.ruleForm.checkValue){
              this.$message({
                message: '请勾选注意事项！',
                type: 'warning'
              });
              return
            }
            console.log('表单校验通过，提交的表单数据：', this.ruleForm)

            var params = {
              school: this.ruleForm.school,
              contact: this.ruleForm.contact,
              phone: this.ruleForm.phone,
              address: this.ruleForm.address,
              email: this.ruleForm.email,
              // product1: this.product1?this.product1:undefined,
              // product1Desc:this.product1?this.ruleForm.product1Desc:undefined,
              // product2: this.product2?this.product2:undefined,
              // product2Desc:this.product2?this.ruleForm.product2Desc:undefined,
            }
            
            if(this.product1){
              params.product1 = this.product1
              params.product1Desc = this.ruleForm.product1Desc
            }
            if(this.product2){
              params.product2 = this.product2
              params.product2Desc = this.ruleForm.product2Desc
            }
            console.log('params',params)
            this.loading = true;
            postAction(this.url.submitUrl, params)
              .then(res => {
                if(res.data.code===0){
                  this.resetForm('ruleForm')
                  this.dialogVisible=true
                  // this.$message({
                  //   message: '下单成功！',
                  //   type: 'success'
                  // });
                 
                }else{
                  this.$message.error(res.data.message);
                }
                this.loading = false;
            });
            
          } else {
            console.log('表单校验不通过');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.ruleForm.product1Desc=''
        this.plusShow=false
        this.ruleForm.publicMCU2=[]
        this.ruleForm.lowPowerMCU2=[]
        this.ruleForm.seriesUSB2=[]
        this.ruleForm.product2Desc=''
        this.product1=''
        this.product2=''
        // this.ruleForm.otherDesc=''
        this.ruleForm.checkValue=false
        this.dialogVisible=false
      }
  }
};
</script>

<style scoped lang="less">
.container {
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  margin-right: auto;
  margin-left: auto;
  box-shadow: 0 1px 5px rgba(0,0,0,0.1),0 0 10px rgba(0,0,0,0) inset;
  padding: 30px 20px; 
}

.el-form-item__label-wrap {
  margin-left: 0px !important;
}
.el-form-item{
  margin-bottom: 18px;
}
.borderClass{
  // border: 1px #ccc solid;
}
.chipModel{
  color: #409eff;
  text-decoration:underline;
}
.textInfo{
  text-align: left;
  font-size: 14px;
  margin-bottom: 25px;
  // border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

</style>
